module.exports = __webpack_public_path__ + "8db70de70dc86b93f5565c2a9e15690e.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/projekte/festival02.jpg
// module id = 511
// module chunks = 0